import { Box, Pressable, Text } from 'native-base'

import { Icon } from './Icon'

import { useNavigation, useTranslation } from '~hooks'

type PropsType = {
  onBackPress?: () => void
}

export const WebBackButtonBar = ({ onBackPress }: PropsType) => {
  const { goBack } = useNavigation()
  const { t } = useTranslation()
  return (
    <Box py="4">
      <Pressable bgColor="background" flexDir="row" onPress={onBackPress || goBack} flex={0}>
        <Icon name="arrow-left-line" size={20} color="main" />
        <Text bold>{t('common.back')}</Text>
      </Pressable>
    </Box>
  )
}
